import * as UserAction from './user.actions';
import {User} from '../user.model';

export interface State {
  user: User;
}

const initialState: State = {
  user: null
};

export function userReducer(state = initialState, action: UserAction.UserActions) {
  switch (action.type) {
    case UserAction.SET_USER:
      return {
        ...state,
        user: action.payload
      };
  }
  return state;
}
